(function() {
  'use strict';

  var content = document.querySelector('.article-template__content');
  if (!content) return;

  var heroImage = document.querySelector('.article-template img');
  var heroImageUrl = heroImage ? (heroImage.currentSrc || heroImage.src) : '';
  var pageUrl = window.location.href.split('#')[0];

  document.querySelectorAll('script[type="application/ld+json"]').forEach(function(script) {
    var data;
    try {
      data = JSON.parse(script.textContent);
    }
    catch (e) {
      return;
    }

    if (!data || data['@type'] !== 'Recipe') return;

    if (!data.image && heroImageUrl) {
      data.image = [heroImageUrl];
    }

    if (!data.url) {
      data.url = pageUrl;
    }

    if (Array.isArray(data.recipeInstructions)) {
      data.recipeInstructions = data.recipeInstructions.map(function(step, index) {
        if (!step || step['@type'] !== 'HowToStep') return step;

        if (!step.name && step.text) {
          step.name = step.text.split('.')[0].substring(0, 80);
        }

        if (!step.url) {
          step.url = pageUrl + '#recipe-step-' + (index + 1);
        }

        if (!step.image && heroImageUrl) {
          step.image = heroImageUrl;
        }

        return step;
      });
    }

    script.textContent = JSON.stringify(data);
  });

  // Find FAQ section — look for heading containing "FAQ" or "Frequently Asked"
  var headings = content.querySelectorAll('h2, h3');
  var faqStartIndex = -1;
  var faqHeadingLevel = null;

  for (var i = 0; i < headings.length; i++) {
    var text = headings[i].textContent.trim().toLowerCase();
    if (text.indexOf('faq') !== -1 || text.indexOf('frequently asked') !== -1) {
      faqStartIndex = i;
      faqHeadingLevel = headings[i].tagName;
      break;
    }
  }

  if (faqStartIndex === -1) return;

  // Collect Q&A pairs — questions are sub-headings after the FAQ heading
  var faqItems = [];
  var questionLevel = faqHeadingLevel === 'H2' ? 'H3' : 'H4';

  for (var j = faqStartIndex + 1; j < headings.length; j++) {
    var heading = headings[j];

    // Stop if we hit another heading at the same or higher level as FAQ heading
    if (heading.tagName === faqHeadingLevel ||
        (faqHeadingLevel === 'H3' && heading.tagName === 'H2')) {
      break;
    }

    // This heading is a question
    var question = heading.textContent.trim();
    if (!question) continue;

    // Collect answer text — all sibling elements until next heading
    var answer = '';
    var sibling = heading.nextElementSibling;
    while (sibling && sibling.tagName !== 'H2' && sibling.tagName !== 'H3' && sibling.tagName !== 'H4') {
      var text = sibling.textContent.trim();
      if (text) {
        answer += (answer ? ' ' : '') + text;
      }
      sibling = sibling.nextElementSibling;
    }

    if (question && answer) {
      faqItems.push({
        question: question.replace(/"/g, '\\"'),
        answer: answer.replace(/"/g, '\\"').substring(0, 500)
      });
    }
  }

  if (faqItems.length < 2) return;

  // Build FAQ schema JSON-LD
  var schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqItems.map(function(item) {
      return {
        '@type': 'Question',
        'name': item.question,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': item.answer
        }
      };
    })
  };

  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
})();
